// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { styled } from "@mui/material/styles";
export var DrawerStyles = {
    SubTitle: styled("div")(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        color: rgba(0, 0, 0, 0.6);\n        font-size: 14px;\n        font-family: Roboto;\n        font-weight: 400;\n        line-height: 20.02px;\n        letter-spacing: 0.17px;\n        word-wrap: break-word;\n    "], ["\n        color: rgba(0, 0, 0, 0.6);\n        font-size: 14px;\n        font-family: Roboto;\n        font-weight: 400;\n        line-height: 20.02px;\n        letter-spacing: 0.17px;\n        word-wrap: break-word;\n    "]))),
    Wrapper: styled("div")(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n        padding: 0 15px;\n    "], ["\n        padding: 0 15px;\n    "]))),
};
var templateObject_1, templateObject_2;
